export default "__VITE_ASSET__ab9be33a__"